import axios from "axios";
import { SweetAlertBasic } from "../../sweetAlert";
import { clientAxios8080 } from "../../configs/axios";

export function getRepositorio() {
  return async (dispatch) => {
    dispatch(repositorioInit());
    try {
      const response = await axios.get("/repository");
      const data = await response.data;
      dispatch(repositorioSuccess(data));
    } catch (error) {
      dispatch(repositorioError(error));
    }
  };
}

export function addDocument(document) {
  return async (dispatch) => {
    dispatch(documentInit());
    const headersDocument = {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
    };

    try {
      const response = await clientAxios8080.get(
        "/file/upload/multipart/",
        headersDocument
      );
      const data = await response.data;
      dispatch(documentSuccess(data));
      SweetAlertBasic(
        "success",
        "Bien Hecho",
        "Se ha creado el documento exitosamente"
      );
    } catch (errorDocument) {
      dispatch(documentError(errorDocument));
      SweetAlertBasic(
        "error",
        "Algo salio mal",
        "Vuelve a intentarlo más tarde"
      );
    }
  };
}

export function addFolder(folder) {
  console.log("folder", folder);
  return async (dispatch) => {
    dispatch(folderInit());
    try {
      const headersFolder = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      };
      const response = await clientAxios8080.get(
        "/file/create/directory/",
        headersFolder
      );
      const data = await response.data;
      dispatch(folderSuccess(data));
      SweetAlertBasic(
        "success",
        "Bien Hecho",
        "Se ha creado el folder exitosamente"
      );
    } catch (errorFolder) {
      dispatch(folderError(errorFolder));
      SweetAlertBasic(
        "error",
        "Algo salio mal",
        "Vuelve a intentarlo más tarde"
      );
    }
  };
}

// Repository Init
const repositorioInit = () => ({ type: "VIEW_REPOSITORIO_INIT" });
const repositorioError = (error) => ({
  type: "VIEW_REPOSITORIO_ERROR",
  payload: error,
});
const repositorioSuccess = (data) => ({
  type: "VIEW_REPOSITORIO_SUCCESS",
  payload: data,
});

// Document Init
const documentInit = () => ({ type: "DOCUMENT_INIT" });
const documentSuccess = (document) => ({
  type: "DOCUMENT_SUCCESS",
  payload: document,
});
const documentError = (errorDocument) => ({
  type: "DOCUMENT_ERROR",
  payload: errorDocument,
});

// Folder Init
const folderInit = () => ({ type: "FOLDER_INIT" });
const folderSuccess = (createFolder) => ({
  type: "FOLDER_SUCCESS",
  payload: createFolder,
});
const folderError = (errorFolder) => ({
  type: "FOLDER_ERROR",
  payload: errorFolder,
});

const initialState = {
  name: "repositorio",
  state: false,
  loading: true,
  repository: [],
  document: [],
  folder: [],
};

export default function init(state = initialState, action) {
  switch (action.type) {
    case "VIEW_REPOSITORIO_INIT":
      return {
        ...state,
        loading: true,
      };

    case "FOLDER_INIT":
      return {
        ...state,
        loading: true,
        document: [...state?.document],
        folder: [...state?.folder],
      };
    case "DOCUMENT_INIT":
      return {
        ...state,
        loading: true,
        document: [...state?.document],
        folder: [...state?.folder],
      };
    case "VIEW_REPOSITORIO_SUCCESS":
      return {
        ...state,
        loading: true,
        repository: action.payload,
      };
    case "VIEW_REPOSITORIO_ERROR":
      return {
        state: false,
        loading: true,
        error: action.payload,
      };
    case "FOLDER_SUCCESS":
      return {
        ...state,
        loading: true,
        folder: [...state.folder, action.payload],
      };
    case "DOCUMENT_SUCCESS":
      return {
        ...state,
        loading: true,
        document: [...state.document, action.payload],
      };
    default:
      return {
        ...state,
      };
  }
}

